
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/[category]",
      function () {
        return require("private-next-pages/shops/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops/[category]"])
      });
    }
  